"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerApp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("./components");
const TrainerContext_1 = require("./TrainerContext");
function TrainerApp({ autoStart = true, canvasProps, children, onLoadingStateChange, style, trainer, ...props }) {
    var _a;
    const activeTrainer = (0, react_1.useRef)(null);
    const canvasRef = (0, react_1.useRef)(null);
    const playableAreaRef = (0, react_1.useRef)(null);
    const [playableArea, setPlayableArea] = (0, react_1.useState)(null);
    const loadingListener = (0, react_1.useRef)(onLoadingStateChange);
    loadingListener.current = onLoadingStateChange;
    const setPlayableAreaRef = (0, react_1.useCallback)((element) => {
        playableAreaRef.current = element;
        setPlayableArea(element);
    }, []);
    (0, react_1.useLayoutEffect)(() => {
        const canvas = canvasRef.current;
        if (!canvas || activeTrainer.current === trainer)
            return;
        activeTrainer.current = trainer;
        trainer.mount(canvas, playableAreaRef.current);
        void trainer.load({
            onStateChange: (state) => {
                var _a;
                if (activeTrainer.current === trainer)
                    (_a = loadingListener.current) === null || _a === void 0 ? void 0 : _a.call(loadingListener, state);
            },
        }).then(() => {
            if (autoStart && activeTrainer.current === trainer)
                trainer.start();
        }).catch(() => undefined);
        return () => {
            if (activeTrainer.current === trainer)
                activeTrainer.current = null;
            trainer.dispose();
        };
    }, [autoStart, trainer]);
    return ((0, jsx_runtime_1.jsx)(TrainerContext_1.TrainerProvider, { trainer: trainer, children: (0, jsx_runtime_1.jsxs)(components_1.GameOverlayProvider, { target: playableArea, children: [(0, jsx_runtime_1.jsxs)("div", { ...props, style: { display: "flex", inset: 0, overflow: "hidden", position: "fixed", ...style }, children: [(0, jsx_runtime_1.jsx)(components_1.PlayableArea, { ref: setPlayableAreaRef, children: (0, jsx_runtime_1.jsx)("canvas", { id: "world", ...canvasProps, ref: canvasRef, onContextMenu: (_a = canvasProps === null || canvasProps === void 0 ? void 0 : canvasProps.onContextMenu) !== null && _a !== void 0 ? _a : ((event) => event.preventDefault()), style: {
                                    height: "100%",
                                    imageRendering: "pixelated",
                                    inset: 0,
                                    position: "absolute",
                                    width: "100%",
                                    ...canvasProps === null || canvasProps === void 0 ? void 0 : canvasProps.style,
                                } }) }), children] }), (0, jsx_runtime_1.jsx)(components_1.PauseController, {})] }) }));
}
exports.TrainerApp = TrainerApp;
